import { render } from "./support.vue?vue&type=template&id=26659bb9&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"

import "./support.vue?vue&type=style&index=0&id=26659bb9&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26659bb9"]])

export default __exports__